import { Card, Row, Col, Stack, Button, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../../config';
import { MdLocationOn, MdPhone, MdDeleteOutline, MdEdit, MdAccessTime } from 'react-icons/md';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { showModal } from '../../../store/slices/modal/modalSlice';
import { deleteLocationByLocationId } from '../../../store/slices/location/locationThunk';
import { PERMISSIONS } from '../../../permissions/permissions';
import { usePermission } from '../../../hooks/usePermission';

export const CurrentLocationCard = memo(() => {
  const navigate = useNavigate();
  const { currentLocation } = useSelector((store) => store.location);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const canDeleteLocation = usePermission(PERMISSIONS.MENU_MANAGEMENT.DELETE);

  if (!currentLocation) return null;

  const imagePath = currentLocation.image?.[0] || '';
  const fullImageUrl = imagePath ? `${IMAGE_BASE_URL}${imagePath}` : null;

  const onDelete = (id) => {
    dispatch(
      showModal({
        title: t('location.deleteLocation'),
        message: t('location.areyousure'),
        type: 'confirm',
        onConfirm: () => deleteCategory(id)
      })
    );
  };

  const deleteCategory = async (id) => {
    try {
      await dispatch(deleteLocationByLocationId(id)).unwrap();
      navigate('/location', { replace: true });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Row>
      <Col md={6}>
        <Card className="border-0 shadow-sm overflow-hidden" style={{ borderRadius: '16px', backgroundColor: '#fff' }}>
          {/* Image Section with Theme Overlays */}
          <div style={{ height: '60vh', position: 'relative', padding: '20px', borderRadius: '16px' }}>
            <Card.Img
              src={fullImageUrl || '/assets/images/no-image-placeholder.png'}
              style={{ objectFit: 'cover', height: '100%', width: '100%', borderRadius: '12px' }}
            />
          </div>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="border-0 shadow-sm overflow-hidden" style={{ borderRadius: '16px', backgroundColor: '#fff' }}>
          <Card.Body className="p-4">
            {/* Title & Badge */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h3 className="fw-bold mb-1" style={{ letterSpacing: '-0.5px' }}>
                  {currentLocation.name}
                </h3>
                <small className="text-muted fw-bold text-uppercase" style={{ fontSize: '10px' }}>
                  ID: {currentLocation.id} • {currentLocation.restaurantId || 'Standalone'}
                </small>
              </div>
              {/* <Badge
                style={{
                  backgroundColor: 'var(--pc-sidebar-active-color)!important',
                  color: '#000',
                  padding: '6px 12px',
                  borderRadius: '8px'
                }}
              >
                Active
              </Badge> */}
            </div>

            <div className="d-flex align-items-center mb-2">
              <MdLocationOn className="me-2" style={{ color: 'var(--pc-sidebar-active-color)' }} size={18} />
              <span className="text-muted small">{currentLocation.address}</span>
            </div>

            <div className="d-flex align-items-center mb-4">
              <MdPhone className="me-2" style={{ color: 'var(--pc-sidebar-active-color)' }} size={18} />
              <span className="text-muted small">
                {currentLocation.countryCode}-{currentLocation.phone}
              </span>
            </div>

            {/* Time Slots - Using Tinted backgrounds of your Yellow color */}
            <Row className="g-3">
              <Col xs={6}>
                <div
                  className="p-3 rounded-4 text-center"
                  style={{
                    background: 'rgba(240, 198, 21, 0.12)', // 12% opacity of #F0C615
                    border: '1px solid rgba(240, 198, 21, 0.2)'
                  }}
                >
                  <MdAccessTime className="mb-1" style={{ color: '#8a6d00' }} />
                  <div className="fw-bold d-block small" style={{ color: '#000' }}>
                    {currentLocation.openingTime}
                  </div>
                  <div className="text-muted" style={{ fontSize: '9px', fontWeight: '800' }}>
                    {t('location.opening')}
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div
                  className="p-3 rounded-4 text-center"
                  style={{
                    background: 'rgba(240, 198, 21, 0.12)',
                    border: '1px solid rgba(240, 198, 21, 0.2)'
                  }}
                >
                  <MdAccessTime className="mb-1" style={{ color: '#8a6d00' }} />
                  <div className="fw-bold d-block small" style={{ color: '#000' }}>
                    {currentLocation.closingTime}
                  </div>
                  <div className="text-muted" style={{ fontSize: '9px', fontWeight: '800' }}>
                    {t('location.closing')}
                  </div>
                </div>
              </Col>
              <Col>
                <div className="position-absolute" style={{ top: '15px', right: '20px' }}>
                  <Stack direction="horizontal" gap={2}>
                    <Button
                      variant="white"
                      className="shadow-sm rounded-circle p-2 border-0"
                      onClick={() => navigate(`/location/${currentLocation.id}/edit-location`)}
                      style={{ backgroundColor: 'black', width: '38px', height: '38px' }}
                    >
                      <MdEdit size={20} style={{ color: 'var(--pc-sidebar-active-color)' }} />
                    </Button>
                    {canDeleteLocation && (
                      <Button
                        variant="white"
                        className="shadow-sm rounded-circle p-2 border-0"
                        onClick={() => {
                          onDelete(currentLocation.id);
                        }}
                        style={{ backgroundColor: '#fff', width: '38px', height: '38px' }}
                      >
                        <MdDeleteOutline size={20} className="text-danger" />
                      </Button>
                    )}
                  </Stack>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
});

{
  /* Floating Actions - White circles with Yellow icons */
}
